import React from 'react';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

import { setDayjsLocale } from '../../../../../utils/setDayjsLocale';
import { getPickersLocaleText } from '../../../../../utils/muiPickersLocaleText';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

export function useCalendarLocale(language) {
  const [pickersKey, setPickersKey] = React.useState('en');
  const [adapterLocale, setAdapterLocale] = React.useState('en');

  React.useEffect(() => {
    let alive = true;

    (async () => {
      const nextLocale = await setDayjsLocale(language);
      if (!alive) return;

      dayjs.updateLocale(nextLocale.adapterLocale, { weekStart: 1 });
      setAdapterLocale(nextLocale.adapterLocale);
      setPickersKey(nextLocale.pickersLocaleKey);
    })();

    return () => {
      alive = false;
    };
  }, [language]);

  const localeText = React.useMemo(() => getPickersLocaleText(pickersKey), [pickersKey]);

  return {
    adapterLocale,
    localeText,
  };
}
